module.exports = function() {
  return new Worker(__webpack_public_path__ + "a0f41af068005583f079.worker.js");
};